import React from 'react';
import BaseMenuOptions from './BaseMenuOptions';
import { getAdminMenuItems } from './menuConfig';
import RegionalService from '../../services/RegionalService';
import {
  isOpenAIAssistantEnabled as hasOpenAIAssistantFeature,
  isRagFlowAssistantEnabled as hasRagFlowAssistantFeature
} from '../../utils/adminMenu';

const AdminGeneralMenuOptions = ({ user, isGptClassicEnabled, isOpenAIAssistantEnabled, isRagFlowAssistantEnabled, extraItems = [], activeItemId, onSelect }) => {
  const featureFlags = RegionalService.getFeatureFlags();
  const resolvedOpenAIAssistantEnabled = isOpenAIAssistantEnabled ?? hasOpenAIAssistantFeature(featureFlags);
  const resolvedRagFlowAssistantEnabled = isRagFlowAssistantEnabled ?? hasRagFlowAssistantFeature(featureFlags);

  return (
    <BaseMenuOptions
      items={getAdminMenuItems({
        user,
        isGptClassicEnabled,
        isOpenAIAssistantEnabled: resolvedOpenAIAssistantEnabled,
        isRagFlowAssistantEnabled: resolvedRagFlowAssistantEnabled,
        extraItems
      })}
      activeItemId={activeItemId}
      onSelect={onSelect}
    />
  );
};

export default AdminGeneralMenuOptions;
